import { HorizontalFormFieldStyle } from "../../formFieldLabelPositioning/styles/Styles";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { Checkbox } from "../index";

export const ReadOnlyCheckField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    // initialValue is set to false to avoid undefined sent to BE in a required field
    return (
        <HorizontalFormFieldStyle key={`${field.name}FormControl `} name={field.name} rules={rules} initialValue={false}>
            <Checkbox key={field.name} name={field.name} label=" " readOnly={readOnly} />
        </HorizontalFormFieldStyle>
    );
};
